import "babel-polyfill"
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import {createStore, applyMiddleware, compose} from 'redux'
import rootReducer from './reducer/RootReducer'
import DocumentSearch from './documentSearch/DocumentSearch'
import * as serviceWorker from './serviceWorker'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './saga/rootSaga';
import {Saga as searchSaga} from './saga/initSaga';
import {HISTORY} from "./util/History";

import Datagrid from "./datagrid/Datagrid";
import tableRootReducer from './datagrid/RootReducer'
import tableRootSaga from './datagrid/rootSaga'
import {Saga as tableSaga} from './datagrid/actions'

const sagaMiddleware = createSagaMiddleware();

if (!document.getElementById('datagrid')) {

  const store = createStore(rootReducer, compose(applyMiddleware(sagaMiddleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() : f => f));

  sagaMiddleware.run(rootSaga);

  store.dispatch(searchSaga.initialise());

  ReactDOM.render(
    <Provider store={store}>
      <DocumentSearch/>
    </Provider>
    , document.getElementById('root')
  );

} else {

  const store = createStore(tableRootReducer, compose(applyMiddleware(sagaMiddleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() : f => f));

  sagaMiddleware.run(tableRootSaga);

  store.dispatch(tableSaga.initialise(HISTORY.location.search));

  ReactDOM.render(
    <Provider store={store}>
      <Datagrid/>
    </Provider>
    , document.getElementById('datagrid')
  );

}

window.addEventListener("beforeunload", function (event) {
  const doc = document.documentElement;
  const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  //store the old scroll position in the history before they leave
  HISTORY.replace(HISTORY.location.search, {scrollTop: top});
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
